module.exports = __webpack_public_path__ + "static/media/15.25ab336d.jpg";